export default "__VITE_ASSET__f90a796a__"